import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Observable} from 'rxjs';
import {API_URL} from '../../environments/environment';
import {SNACKBAR_CHAIN_ADD_ERROR, SNACKBAR_CHAIN_ADD_SUCCESS} from '../../locale/consts.en';
import {Chain, ChangeChainCommand, CreateChainCommand} from './chains.model';

@Injectable({
  providedIn: 'root'
})
export class ChainsService {
  private http = inject(HttpClient);
  private snackBar = inject(MatSnackBar);


  getAllChains(): Observable<Chain[]> {
    return this.http.get<Chain[]>(API_URL + 'chain');
  }

  createChain(cmd: CreateChainCommand): Observable<HttpResponse<unknown>> {
    console.log('Update chain', cmd.name);
    return this.http.post<CreateChainCommand>(API_URL + 'chain', cmd, {
      observe: 'response'
    });
  }

  updateChain(cmd: ChangeChainCommand): Observable<HttpResponse<unknown>> {
    return this.http.put<ChangeChainCommand>(API_URL + 'chain/update', cmd, {
      observe: 'response'
    });
  }

  handleResponse(response: HttpResponse<unknown>) {
    if (response.status === 200 || response.status === 201) {
      this.snackBar.open(SNACKBAR_CHAIN_ADD_SUCCESS, '', {duration: 2000, panelClass: 'app-snackbar-success'});
      console.log('Save OK!');

    } else {
      this.snackBar.open(SNACKBAR_CHAIN_ADD_ERROR, '', {duration: 2000, panelClass: 'app-snackbar-alert'});
    }

  }
}
